import React from "react";
import { ContinueButton, ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { LoadToTrailerModal } from "./LoadToTrailerModal";

export interface LoadToTrailerErrorModalProps {
  title: string;
  text: string;
  hideModalValue: LoadToTrailerModal;
}

export const LoadToTrailerErrorModal: React.FC<LoadToTrailerErrorModalProps> = ({ title, text, hideModalValue }) => {
  const { hideModal } = useSortationModal();
  return (
    <ModalTemplate
      title={<FormattedMessage id="sortation.loadToTrailer.errorModalTitle" defaultMessage={title} />}
      text={<FormattedMessage id="sortation.loadToTrailer.errorModalText" defaultMessage={text} />}
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
    >
      <ContinueButton block onClick={() => hideModal(hideModalValue)} />
    </ModalTemplate>
  );
};
